<template>
  <section id="about" class="about section-show">
    <div class="container">
      <div class="section-title">
        <h2>درخواست واریزسودسهام</h2>
      </div>
      <div
        v-if="status == 5 || status == 4 || status == 6"
        class="alertmessage"
      >
        <p v-show="status == 5">
          نقص اطلاعات؛ لطفا تمام فیلدهای اجباری در قسمت اطلاعات هویتی، ارتباطی و
          مالی را به دقت وارد نمائید
        </p>
        <p v-show="status == 4">شماره شبا نامعتبر است</p>
        <p v-show="status == 6">
          شماره شبا تکراری است. لطفا مجددا اصلاح بفرمائید
        </p>
      </div>
      <div class="containeryear">
        <div class="headyear"><p>سهام شما در</p></div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="year1"
            :value="1399"
            :checked="filteryear == 1399"
            @change="check(1399)"
          />
          <label class="form-check-label" for="year1">سال 1399</label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label" for="year2">سال 1400</label>
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="year2"
            :value="1400"
            :checked="filteryear == 1400"
            @change="check(1400)"
          />
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label" for="year2">سال 1401</label>
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="year3"
            :value="1401"
            :checked="filteryear == 1401"
            @change="check(1401)"
          />
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label" for="year2">سال 1402</label>
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="year4"
            :value="1402"
            :checked="filteryear == 1402"
            @change="check(1402)"
          />
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label" for="year2">سال 1403</label>
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="year4"
            :value="1403"
            :checked="filteryear == 1403"
            @change="check(1403)"
          />
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label" for="year2">سال 1404</label>
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="year4"
            :value="1404"
            :checked="filteryear == 1404"
            @change="check(1404)"
          />
        </div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="cotnainertab" v-if="isDividends">
          <TabGroup @change="changeTab" :selectedIndex="selectedTab">
            <TabList class="dividcontainer">
              <Tab
                class="btn"
                v-for="item in AllDividends"
                v-slot="{ selected }"
                :key="item.idNamad"
                ><span :class="[selected ? 'activetab' : 'tab']"
                  >{{ item.namad }}
                </span></Tab
              >
            </TabList>
            <TabPanels class="mt-2 panel">
              <TabPanel
                class=""
                v-for="divid in AllDividends"
                :key="divid.idNamad"
              >
                <div class="contentpanel">
                  <div class="contentpanel__img">
                    <img :src="getURL(divid.idNamad)" alt="{{divid.namad}}" />
                    <p>
                      وضعیت سهام {{ divid.namad }} شما درسال {{ divid.year }}
                    </p>
                  </div>
                  <div class="contentpanel__divi">
                    <div class="divcontent">
                      <p class="first">کل سهام</p>
                      <p class="last">{{ divid.totalShares }}</p>
                    </div>
                    <div class="divcontent">
                      <p class="first">سود سهام</p>
                      <p class="last">{{ divid.interest }}</p>
                    </div>
                    <div class="divcontent">
                      <p class="first">تاریخ مجمع</p>
                      <p class="last">{{ divid.syncDate }}</p>
                    </div>
                    <div class="divcontent">
                      <p class="first">وضعیت پرداخت</p>
                      <p class="last">
                        {{ divid.paymentStatusName }}
                      </p>
                    </div>
                    <div class="divcontent">
                      <p class="first">تاریخ آخرین وضعیت</p>
                      <p class="last">
                        {{ divid.statusEditTimeStampstring }}
                      </p>
                    </div>
                  </div>
                  <div>
                    <div class="contentpanel__tick">
                      <input
                        type="checkbox"
                        style="margin-left: 5px; margin-top: 5px"
                        :disabled="divid.confirm"
                        :checked="divid.confirm"
                        @change="onChange"
                      />
                      <p>
                        اینجانب مسئولیت صحت اطلاعات بانکی و هویتی وارد شده را می
                        پذیرم و مایل به دریافت سودسهام می باشم
                      </p>
                    </div>
                  </div>
                  <div class="contentpanel__btn">
                    <button
                      type="button"
                      class="btnsend"
                      @click="sendrequest(divid.year, divid.idNamad, divid.seq)"
                      :disabled="
                        divid.confirm ||
                        divid.interest == 0 ||
                        divid.PaymentStatusID == 3
                      "
                    >
                      ارسال درخواست
                    </button>
                  </div>
                </div>
              </TabPanel>
            </TabPanels>
          </TabGroup>
        </div>
        <div v-else>
          <h6 style="margin-top: 60px">شما دراین سال سهامی ندارید</h6>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Profile from "../assets/img/profile.png";
import baharan from "../assets/img/baharan.png";
import ghponeh from "../assets/img/ghponeh.png";
import shahdab from "../assets/img/shahdab.png";
import tabarok from "../assets/img/tabarok.png";
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from "@headlessui/vue";
import { GetDivid, ConfirmTick } from "../API/API";
export default {
  components: { TabGroup, TabList, Tab, TabPanels, TabPanel },
  name: "Dividends",
  data() {
    return {
      Profile,
      baharan,
      ghponeh,
      shahdab,
      tabarok,
      AllDividends: {},
      isDividends: true,
      filteryear: [],
      status: {},
      disabled: {},
      Checked: false,
      selectedTab: 0,
      sendtick: {
        Seq: "",
        Year: "",
        NamadID: "",
        CheckBoxState: "",
      },
    };
  },
  async created() {
    this.AllDividends = (
      await GetDivid(this.$store.getters.seq, "1399")
    ).data.result;
    console.log(this.AllDividends);
    if (this.AllDividends != null) {
      this.isDividends = true;
      this.filteryear = this.AllDividends[0].year;
      this.AllDividends.forEach((divds) => {
        if (divds.paymentStatusID == 5) {
          this.status = 5;
        }
        if (divds.paymentStatusID == 4) {
          this.status = 4;
        }
        if (divds.paymentStatusID == 6) {
          this.status = 6;
        }
      });
    } else {
      this.filteryear = 1399;
      this.isDividends = false;
    }
  },
  methods: {
    async check(year) {
      this.AllDividends = {};
      this.AllDividends = (
        await GetDivid(this.$store.getters.seq, year)
      ).data.result;
      console.log(this.AllDividends);
      if (this.AllDividends == null) {
        this.filteryear = year;
        this.isDividends = false;
      } else {
        this.isDividends = true;
      }
    },
    changeTab(index) {
      this.selectedTab = index;
      console.log(index);
    },
    onChange(e) {
      if (e.target.checked) {
        this.Checked = true;
      } else {
        this.Checked = false;
      }
    },
    sendrequest(year, idNamad, seq) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: "",
          text: "آیاازارسال درخواست مطمئن هستید؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "بله",
          cancelButtonText: "خیر",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (this.Checked == true) {
              this.sendtick = {
                Seq: seq,
                Year: year,
                NamadID: idNamad,
                CheckBoxState: true,
              };
              ConfirmTick(this.sendtick).then((resp) => {
                if (resp.data.statusCode == 404) {
                  this.$swal({
                    icon: "error",
                    title: "خطا",
                    text: "عملیات باشکست مواجه شد",
                    confirmButtonColor: "#900C3F",
                    confirmButtonText: "باشه",
                  });
                } else if (resp.data.statusCode == 422) {
                  this.$swal({
                    icon: "error",
                    title: "خطا",
                    text: "قبل از تایید، لطفا تمام فیلدهای اجباری در قسمت اطلاعات هویتی و بانکی را وارد نمائید",
                    confirmButtonColor: "#900C3F",
                    confirmButtonText: "باشه",
                  });
                } else {
                  this.$swal({
                    icon: "success",
                    title: "موفق",
                    text: "درخواست شما باموفقیت ثبت شد",
                    confirmButtonColor: "#1e682d",
                    confirmButtonText: "باشه",
                  });
                  this.AllDividends[this.selectedTab].confirm = true;
                }
              });
            } else {
              this.$swal({
                icon: "error",
                title: "خطا",
                text: "لطفا تیک تایید را انتخاب نمایید",
                confirmButtonColor: "#900C3F",
                confirmButtonText: "باشه",
              });
            }
          }
        });
    },
    getURL(id) {
      if (id == 1) {
        return this.tabarok;
      } else if (id == 2) {
        return this.shahdab;
      } else if (id == 3) {
        return this.ghponeh;
      } else if (id == 4) {
        return this.baharan;
      }
    },
  },
};
</script>
<style scoped>
button:disabled {
  cursor: not-allowed;
  background: #ccc;
  border: 1px solid rgb(110, 105, 105);
}
.alertmessage {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  position: relative;
  padding: 0.75rem 1.25rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  margin: 0.5rem;
  font-size: 0.8rem;
  text-align: center;
  font-weight: bold;
  margin-right: 4.7rem;
  margin-left: 4.7rem;
}
.alertmessage p {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  margin-top: 0.5rem;
}
.btn {
  border: none;
  background: none;
  color: #563903;
  font-weight: bold;
}
.btn:hover {
  border: none;
  color: #fff;
}
.panel {
  background: #fff;
  border-radius: 0.75rem;
  margin-left: 10px;
  margin-right: 10px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em,
    rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em,
    rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
}
.contentpanel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 400px;
}
.contentpanel__divi {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 1rem 1.3rem;
  font-size: 0.9rem;
}
.contentpanel__tick {
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 0.9rem;
  margin-top: 30px;
  color: darkred;
  font-weight: bold;
}
.contentpanel__btn {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.contentpanel__img {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-right: 20px;
  /* margin-top: 20px; */
  margin-bottom: 20px;
}
.contentpanel__img p {
  font-weight: bold;
}
.divcontent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.contentpanel__img img {
  width: 50px;
  height: 50px;
  margin-top: -15px;
}
.first {
  color: #8f6008;
}
.last {
  font-weight: bold;
}

.section-title h2 {
  font-size: 18px;
  font-weight: 700;
  padding: 0;
  line-height: 18px;
  margin: 30px 0 20px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #111;
  font-family: "iransans", Lato, sans-serif;
  padding-bottom: 15px;
  position: relative;
}
.section-title h2::after {
  content: "";
  width: 230px;
  height: 2px;
  background: #d1a44f;
  bottom: 0;
  top: auto;
  position: absolute;
  right: 0;
}
.containeryear {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 3rem;
}
.headyear {
  margin-left: 40px;
  font-weight: bold;
}
.npanel {
  background: #fff;
  margin-left: 10px;
  margin-right: 10px;
  box-shadow: unset;
}
.nothing {
  display: flex;
  justify-content: center;
  padding-top: 50px;
  font-size: 1.5rem;
  color: red;
  font-weight: bold;
  min-height: 400px;
}
.cotnainertab {
  margin-top: 30px;
  width: 90%;
}
@media screen and (max-width: 767px) {
  .cotnainertab {
    margin-top: unset;
    width: unset;
  }
  .contentpanel__img {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-right: unset;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .contentpanel__img p {
    font-size: 0.75rem;
    font-weight: bold;
  }
  .contentpanel__divi {
    margin-left: 5px;
    margin-right: 5px;
    justify-content: center;
    padding: 0.5rem 0;
    font-size: 0.7rem;
  }
  .contentpanel__tick {
    font-size: 0.7rem;
    color: darkred;
    font-weight: bold;
  }
  .containeryear {
    justify-content: space-between;
    margin-top: 2rem;
  }
  .form-check {
    margin-left: unset;
  }
  .headyear {
    margin-left: 30px;
  }
  .form-check-inline {
    margin-right: unset;
  }
}
</style>
